var exports = {
  "mX": "xaee3c4fa--4dac86--post_card",
  "KK": "xaee3c4fa--4dac86--author-container",
  "Dq": "xaee3c4fa--4dac86--post-card-top-likes",
  "T_": "xaee3c4fa--4dac86--card-footer-container",
  "Kp": "xaee3c4fa--4dac86--card-footer-container-question",
  "Du": "xaee3c4fa--4dac86--post-card-info",
  "sy": "xaee3c4fa--4dac86--post-card-info__author",
  "BG": "xaee3c4fa--4dac86--post-card-info__date",
  "t4": "xaee3c4fa--4dac86--post-card-info__views",
  "LO": "xaee3c4fa--4dac86--post-card-info__comments",
  "xV": "xaee3c4fa--4dac86--comments-icon",
  "on": "xaee3c4fa--4dac86--post-card-content",
  "yH": "xaee3c4fa--4dac86--post-card-content-blog-question",
  "nE": "xaee3c4fa--4dac86--post-card-content__main-img-container",
  "jh": "xaee3c4fa--4dac86--post-card-content__main-img",
  "a7": "xaee3c4fa--4dac86--post-card-content__summary",
  "iP": "xaee3c4fa--4dac86--post-card-content__summary-empty",
  "Vx": "xaee3c4fa--4dac86--post-card-title",
  "eN": "xaee3c4fa--4dac86--post-card-info-wrap",
  "cH": "xaee3c4fa--4dac86--post-card-info-wrap-blog-question",
  "lo": "xaee3c4fa--4dac86--views-icon",
  "M9": "xaee3c4fa--4dac86--blogs-icon",
  "Pj": "xaee3c4fa--4dac86--blogs-link",
  "ZN": "xaee3c4fa--4dac86--category-name",
  "KL": "xaee3c4fa--4dac86--category-name__empty",
  "dh": "xaee3c4fa--4dac86--subcategory-name",
  "pG": "xaee3c4fa--4dac86--caption",
  "s": "xaee3c4fa--4dac86--ads-caption",
  "$q": "xaee3c4fa--4dac86--accepted-caption",
  "iZ": "xaee3c4fa--4dac86--decline-caption",
  "NZ": "xaee3c4fa--4dac86--draft-caption",
  "PN": "xaee3c4fa--4dac86--post-card-content__text",
  "lY": "xaee3c4fa--4dac86--popup",
  "lM": "xaee3c4fa--4dac86--popup__close-icon",
  "L_": "xaee3c4fa--4dac86--desktop",
  "Hw": "xaee3c4fa--4dac86--mobile",
  "GN": "xaee3c4fa--4dac86--post-card-content-blog-question-empty",
  "Rq": "xaee3c4fa--4dac86--post-card-content__summary-empty-permision-invalid",
  "d$": "xaee3c4fa--4dac86--post-card-content__link-btn",
  "mN": "xaee3c4fa--4dac86--recommended-offers-wrapper",
  "qw": "xaee3c4fa--4dac86--author-articles-wrapper",
  "TN": "xaee3c4fa--4dac86--post-card-content__summary-empty-permision-valid-mobile",
};

module.exports = exports;
